export enum AttachDocumentEntityType {
  ORDER = 'order',
  ORDER_LINE = 'order-line',
  SHIPMENT = 'shipment',
  RFQ = 'RFQ',
  RFQ_LINE = 'RFQ-line',
}
